import type { TypePolicies } from '@apollo/client';

export const adminCachePolicies: TypePolicies = {
  // Enforce merging this non-normalized object types
  RecommendEvent: {
    merge: true,
  },
  Date: {
    merge: true,
  },
  RegistryFulfillment: {
    merge: true,
  },
  RegistryOrderLineItemData: {
    merge: true,
  },
  MonetaryValue: {
    merge: true,
  },
  Currency: {
    merge: true,
  },
  TransferredRegistryData: {
    merge: true,
  },
  LineItem: {
    keyFields: ['locator'],
  },
  RegistryItemProductData: {
    keyFields: ['registryItem', ['id']],
  },
  RegistryItemCount: {
    merge: true,
  },
  ShippingAddress: {
    merge: true,
  },
  WebsiteHeaderPresentationSettings: {
    keyFields: ['id', 'schemaURL', 'websiteLayout'],
  },

  // Enforce id is added to this types so cache can merge them accordingly
  // if keyFields is something other than ['id'] then it should be moved above
  //
  // This acts as a safety net to ensure devs always add the id field
  // to the query response data.
  Event: {
    keyFields: ['id'],
  },
  EventPage: {
    keyFields: ['id'],
  },
  EventInfo: {
    keyFields: ['id'],
  },
};
